/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 12th 2022, 10:03:05 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useAPIFetchItem, APISERVICEPATHS } from "lib/api";
import { ContextTags } from "lib/schemas";

const contextTagsAPI = APISERVICEPATHS.contextTags;

export const useAPIFetchContextTags = () =>
  useAPIFetchItem<ContextTags>({ apiServicePath: contextTagsAPI, makeRequestOnInitialMount: false });
